
  const bannerSlider = document.querySelector('.main_banner.splide');
  if (bannerSlider) {
    const splide = new Splide(bannerSlider, {
      type         : 'loop',
      perPage      : 1,
      autoplay     : true,
      interval     : 5000,
      pauseOnHover : false,
      arrows       : false,
      pagination   : true,
      speed        : 1000,
      wheel        : false,
      releaseWheel : false,
    });

    splide.on('mounted', function () {
      const pagination = bannerSlider.querySelector('.splide__pagination');
      if (pagination) {
        pagination.innerHTML = ''; 
        splide.refresh();
      }
    });

    splide.mount();
  }


  const slidersp = document.querySelectorAll('.custom_product_splide');

  if(slidersp.length > 0){

      slidersp.forEach(function (splideEl) {
    new Splide(splideEl, {
      type: 'slide',
      perPage: 5,
      gap: '3rem',
      pagination: false,
      arrows: true,
      speed: 800,
      perMove: 1, 
      focus  : 0,
      autoplay: true,  
      omitEnd: true,
      interval: 4000,   
      throttle: 300,
      pauseOnHover: true,     
      pauseOnFocus: false,
      breakpoints: {
        1199: {
          perPage: 4,
          gap: '2rem'
        },
        1024: {
          perPage: 3,
          gap: '2rem'
        },
        767: {
          perPage: 2,
          gap: '1rem'
        },
        480: {
          perPage: 1,
          gap: '0.5rem'
        }
      }
    }).mount();
  });


  }




// Initialize Splide slider
const featured_product_tab_slider = document.querySelector('.featured-product-tab-wrapper .splide');
if (featured_product_tab_slider) {
  const splide = new Splide(featured_product_tab_slider, {
    type: 'slide',
    perPage: 4,
    gap: '3rem',
    autoplay: false,
    arrows: true,
    pagination: true,
    breakpoints: {
      1199: { perPage: 4, gap: '2rem' },
      1024: { perPage: 3, gap: '2rem' },
      767: { perPage: 2, gap: '1rem' },
      480: { perPage: 1, gap: '0.5rem' }
    }
  });
  splide.mount();
}




// ================== ELEMENTS ==================
const allTopProductCards = document.querySelectorAll('.display-current-prouduct .product-outer');
const allBottomProductCards = document.querySelectorAll('.featured_prouduct_splide li.splide__slide');
const ADD_TO_CART_BTN = document.querySelector('.display-current-prouduct .add-to-cart-button-wrapper button');
const QUANTITY_INP = document.querySelector('.quantity-seletion-box input');
const PLUS_BTN = document.querySelector('.quantity-seletion-box .plus-btn');
const MINUS_BTN = document.querySelector('.quantity-seletion-box .minus-btn');
const loadingSpnr = document.querySelector('.display-current-prouduct .add-to-cart-button-wrapper .svg-wrapper');

// if (!ADD_TO_CART_BTN || !QUANTITY_INP) {
//   console.warn("Required product elements not found.");
//   return;
// }

let currentQuantityValue = Math.max(1, parseInt(QUANTITY_INP?.value, 10) || 1);
let PRODUCT_ID = null;
let LAST_IMAGE_URL = "";

// ================== UTILITIES ==================
function getSelectedVariant() {
  const currentProduct = document.querySelector('.product-outer.is_currently_selected');
  if (!currentProduct) return null;

  // Single variant
  if (currentProduct.dataset.onlyVaraintId) {
    return {
      dataset: {
        variantId: currentProduct.dataset.onlyVaraintId,
        variantAvaliable: currentProduct.dataset.avalbility === "true",
        inventoryQuantity: parseInt(currentProduct.dataset.inventoryQuantity, 10) || 0,
        variantPrice: currentProduct.querySelector(".selected-variant-price")?.dataset.price || "",
        variantCompatePrice: currentProduct.querySelector(".selected-variant-price")?.dataset.compareAt || "",
        productImage: currentProduct.dataset.productImage || ""
      }
    };
  }

  // Multiple variants
  const checkedRadio = currentProduct.querySelector('input[type="radio"]:checked');
  if (!checkedRadio) return null;

  const variants = currentProduct.querySelectorAll('.varinats_list p');
  return [...variants].find(v => v.dataset.variantTitle?.trim() === checkedRadio.value.trim()) || null;
}

// ================== UPDATE UI ==================
function updateAvailabilityAndPrice() {
  const variant = getSelectedVariant();
  if (!variant) return;

  const currentProduct = document.querySelector('.product-outer.is_currently_selected');
  if (!currentProduct) return;

  const priceWrapper = currentProduct.querySelector(".selected-variant-price");
  const imageWrapper = currentProduct.querySelector(".product_inner_right .image_wpr");

  // ---------- PRICE ----------
  if (priceWrapper) {
    const price = variant.dataset.variantPrice || "";
    const compareAt = variant.dataset.variantCompatePrice || "";

    if (compareAt && compareAt !== price) {
      priceWrapper.innerHTML = `<span>${price}</span> <s>${compareAt}</s>`;
    } else {
      priceWrapper.textContent = price;
    }
    priceWrapper.style.display = "block";
  }

  // ---------- AVAILABILITY ----------
  const available = variant.dataset.variantAvaliable === true;
  const inventoryQty = parseInt(variant.dataset.inventoryQuantity, 10) || 0;

  if (currentQuantityValue > inventoryQty && inventoryQty > 0) {
    currentQuantityValue = inventoryQty;
    QUANTITY_INP.value = inventoryQty;
  }

  const outOfStock = !available || inventoryQty === 0;

  ADD_TO_CART_BTN.disabled = outOfStock;
  ADD_TO_CART_BTN.classList.toggle("disabled", outOfStock);
  if(ADD_TO_CART_BTN){
  ADD_TO_CART_BTN.querySelector("span").textContent = outOfStock ? "Out of Stock" : "Add to cart";

  }

  PRODUCT_ID = variant.dataset.variantId || null;

  // ---------- IMAGE (SAFE & NO BLINK) ----------
  const imageUrl = variant.dataset.variantImage || variant.dataset.productImage || "";
  const imgEl = imageWrapper?.querySelector("img");

  if (imgEl && imageUrl && imageUrl !== LAST_IMAGE_URL) {
    LAST_IMAGE_URL = imageUrl;

    imgEl.style.opacity = "0";
    imgEl.onload = () => (imgEl.style.opacity = "1");
    imgEl.src = imageUrl;
  }
}

// ================== VARIANT EVENTS ==================
function bindVariantEvents() {
  const currentProduct = document.querySelector('.product-outer.is_currently_selected');
  if (!currentProduct) return;

  currentProduct
    .querySelectorAll('input[type="radio"]')
    .forEach(r => r.addEventListener("change", updateAvailabilityAndPrice));

  LAST_IMAGE_URL = "";
  updateAvailabilityAndPrice();
}

// ================== QUANTITY ==================
function changeQuantity(amount) {
  const value = parseInt(QUANTITY_INP?.value, 10);
  currentQuantityValue = Math.max(1, (isNaN(value) ? 1 : value) + amount);
  QUANTITY_INP.value = currentQuantityValue;
  updateAvailabilityAndPrice();
}

PLUS_BTN?.addEventListener('click', () => changeQuantity(1));
MINUS_BTN?.addEventListener('click', () => changeQuantity(-1));

QUANTITY_INP?.addEventListener('input', () => {
  const value = parseInt(QUANTITY_INP.value, 10);
  currentQuantityValue = Math.max(1, isNaN(value) ? 1 : value);
  QUANTITY_INP.value = currentQuantityValue;
  updateAvailabilityAndPrice();
});

// ================== TAB SWITCH ==================
allBottomProductCards.forEach((card, index) => {
  card.addEventListener('click', () => {
    allBottomProductCards.forEach(c => c.classList.remove('is_currently_selected'));
    allTopProductCards.forEach(c => c.classList.remove('is_currently_selected'));

    card.classList.add('is_currently_selected');
    allTopProductCards[index]?.classList.add('is_currently_selected');

    currentQuantityValue = 1;
    QUANTITY_INP.value = 1;

    bindVariantEvents();

    document
      .querySelector('.featured-product-tab-wrapper .content-right')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

// ================== ADD TO CART ==================
ADD_TO_CART_BTN?.addEventListener('click', async () => {
  if (!PRODUCT_ID) return console.warn("No variant selected");

  try {
    ADD_TO_CART_BTN.disabled = true;
    ADD_TO_CART_BTN.classList.add("loading");
    loadingSpnr?.classList.remove("hidden");
    ADD_TO_CART_BTN.querySelector("span")?.classList.add("hidden");

    const cartDrawer = document.querySelector("cart-drawer");

    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: PRODUCT_ID, quantity: currentQuantityValue }],
        sections: cartDrawer?.getSectionsToRender()?.map(s => s.id) || [],
        sections_url: window.location.pathname
      }),
    });

    if (!res.ok) throw new Error("Add to cart failed");

    const data = await res.json();
    cartDrawer?.renderContents(data);
    cartDrawer?.classList.add("animate", "active");
    cartDrawer?.classList.remove("is-empty");

  } catch (err) {
    console.error(err);
  } finally {
    ADD_TO_CART_BTN.disabled = false;
    ADD_TO_CART_BTN.classList.remove("loading");
    loadingSpnr?.classList.add("hidden");
    ADD_TO_CART_BTN.querySelector("span")?.classList.remove("hidden");
  }
});

// ================== INIT ==================
bindVariantEvents();







  const footer = document.querySelector('.footer');
  
  if (footer) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          footer.classList.add('is-loaded');
          observer.unobserve(footer); // Stop watching after it's loaded
        }
      });
    }, { rootMargin: '200px' }); 

    observer.observe(footer);
  }



    const sliders = document.querySelectorAll('.custom_blog_splide');
    if(sliders.length > 0){
        sliders.forEach(function (splideEl) {
    new Splide(splideEl, {
     type: 'slide',
      perPage: 2,
      gap: '3rem',
      pagination: false,
      arrows: true,
      speed: 800,
      perMove: 1, 
      focus  : 0,
      autoplay: true,  
      omitEnd: true,
      interval: 4000,   
      throttle: 300,
      pauseOnHover: true,     
      pauseOnFocus: false,
      breakpoints: {
        1024: {
          perPage: 2,
          gap: '2rem'
        },
        767: {
          perPage: 2,
          gap: '1rem'
        },
        480: {
          perPage: 1,
          gap: '0.5rem'
        }
      }
    }).mount();
  });
      
    }

  


